var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('a',{staticClass:"pagetitle effect-shine",attrs:{"href":"/"}},[_c('h1',[_vm._v("Laravel Migrations Builder")])])])}]

export { render, staticRenderFns }